document.addEventListener('DOMContentLoaded', () => {
  const SITE_KEY = '6LcAh6MrAAAAAFQ8Dljj_GxLcbm64Iw20ku0p4-U';
  const API_URL = 'https://shopify-reviews-backend-ck5t.onrender.com/submit-feedback';

  document.querySelectorAll('.cw-feedback-form').forEach((wrapper) => {
    const mode = wrapper.dataset.feedbackMode;
    const form = wrapper.querySelector('.feed-form');
    const submitBtn = wrapper.querySelector('.feedback-submit-btn');
    const resultEl = wrapper.querySelector('.submit-result');
    const feedbackScore = wrapper.querySelector('.feedback-score');
    const feedComment = wrapper.querySelector('.feed-comment');
    const feedbox = wrapper.querySelectorAll('.feedSelection__item');

    let feedbackSaved = false;
    let feedValue = null;

    function resetFeedbox() {
      feedbox.forEach((s) => {
        s.classList.remove('active');
        s.style.backgroundColor = '';
      });

      feedbackScore.dataset.value = '';
      feedbackSaved = false;
      feedValue = null;
    }

    feedbox.forEach((box, index) => {
      box.addEventListener('mouseenter', () => {
        if (feedbackSaved) return;

        const hue = (index / (feedbox.length - 1)) * 120;
        const hoverColor = `hsl(${hue}, 100%, 50%)`;

        feedbox.forEach((s, i) => {
          s.classList.toggle('active', i <= index);
          s.style.backgroundColor = i <= index ? hoverColor : '';
        });
      });

      box.addEventListener('mouseleave', () => {
        if (feedbackSaved) return;

        feedbox.forEach((s) => {
          s.classList.remove('active');
          s.style.backgroundColor = '';
        });
      });

      box.addEventListener('click', () => {
        feedValue = index;
        feedbackScore.dataset.value = String(feedValue);
        feedbackSaved = true;

        const hue = (index / (feedbox.length - 1)) * 120;
        const selectedColor = `hsl(${hue}, 100%, 50%)`;

        feedbox.forEach((s, i) => {
          s.classList.toggle('active', i <= feedValue);
          s.style.backgroundColor = i <= feedValue ? selectedColor : '';
        });
      });
    });

    submitBtn.addEventListener('click', async (e) => {
      e.preventDefault();

      const recommendScore = feedbackScore.dataset.value;
      const feedbackComment = feedComment.value.trim();

      if (recommendScore === '') {
        resultEl.textContent = 'Please select a recommendation score.';
        return;
      }

      const payload = {
        recommend_score: recommendScore,
        feedback_comment: feedbackComment,
        type: mode === 'auth' ? 'verified-feedback' : 'general-feedback'
      };

      if (mode === 'auth') {
        const params = new URLSearchParams(window.location.search);
        const authToken = params.get('token');

        if (!authToken) {
          resultEl.textContent = '❌ Missing feedback token.';
          return;
        }

        payload.token = authToken;
      }

      if (mode === 'general') {
        const firstName = wrapper.querySelector('.first-name')?.value.trim();
        const lastName = wrapper.querySelector('.last-name')?.value.trim();
        const email = wrapper.querySelector('.email')?.value.trim();

        if (!firstName) {
          resultEl.textContent = 'Please enter your first name.';
          return;
        }

        if (!email) {
          resultEl.textContent = 'Please enter your email address.';
          return;
        }

        payload.store = 'cw';
        payload.first_name = firstName;
        payload.last_name = lastName;
        payload.email = email;
      }

      try {
        await grecaptcha.ready(async () => {
          const captchaToken = await grecaptcha.execute(SITE_KEY, {
            action: 'submit_feedback'
          });

          payload['g-recaptcha-response'] = captchaToken;

          const res = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });

          const result = await res.json();

          if (!res.ok || !result.success) {
            throw new Error(result.error || 'Feedback submit failed');
          }

          resultEl.textContent = '✅ Feedback submitted, thanks!';
          form.reset();
          resetFeedbox();
        });
      } catch (error) {
        console.error(error);
        resultEl.textContent = '❌ Network or server error while submitting feedback.';
      }
    });
  });
});